// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"employeePage_wrapper__3rx2I"};